// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f5bef6b4","613":"3499b57c","977":"712f7cd8"}[chunkId] + ".chunk.js";
};